import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Field = (props) => {
  const filledClassName = props.value ? "filled" : "";
  const controlClassNames = ["control"];

  const justNumberHandler = (evt) => {
    let code = evt.which ? evt.which : evt.keyCode;
    if (code > 31 && (code < 48 || code > 57)) {
      evt.preventDefault();
    }
  };

  if (props.iconLeft) {
    controlClassNames.push("has-icons-left");
  }

  if (props.iconRight) {
    controlClassNames.push("has-icons-right");
  }

  if (props.classesIcon) {
    controlClassNames.push(props.classesIcon);
  }

  return (
    <div className="field">
      {props.label ? <div className="label">{props.label}</div> : null}
      <div className={controlClassNames.join(" ")}>
        {props.type === "textarea" ? (
          <textarea
            className={
              [
                { attr: "textarea", visible: true },
                { attr: filledClassName, visible: true },
              ]
                .filter((attr) => attr.visible)
                .map((attr) => attr.attr)
                .join(" ") +
              " " +
              props.classes
            }
            placeholder={props.placeholder}
            style={{ resize: "none" }}
            value={props.value}
            onChange={props.onChange}
          ></textarea>
        ) : props.type === "select" ? (
          <div className="select is-fullwidth" style={{ marginBottom: "12px" }}>
            <select
              className={
                [
                  { attr: "input", visible: true },
                  { attr: filledClassName, visible: true },
                ]
                  .filter((attr) => attr.visible)
                  .map((attr) => attr.attr)
                  .join(" ") +
                " " +
                props.classes
              }
              value={props.value}
              onChange={props.onChange}
            >
              <option value="" disabled>
                {props.placeholder}
              </option>
              {(props.options || []).map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <input
            className={
              [
                { attr: "input", visible: true },
                { attr: filledClassName, visible: true },
              ]
                .filter((attr) => attr.visible)
                .map((attr) => attr.attr)
                .join(" ") +
              " " +
              props.classes
            }
            type={props.type}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            readOnly={props.readOnly ? true : false}
            onKeyPress={
              props.number
                ? (event) => {
                    justNumberHandler(event);
                  }
                : null
            }
          />
        )}

        {props.iconLeft ? (
          <span className="icon is-left">
            <FontAwesomeIcon icon={props.iconLeft} />
          </span>
        ) : null}

        {props.iconRight ? (
          <span className="icon is-right">
            <FontAwesomeIcon icon={props.iconRight} />
          </span>
        ) : null}
      </div>
      {props.error ? (
        <p className={"help has-text-left " + props.errorClasses}>
          {props.error}
        </p>
      ) : null}
    </div>
  );
};

export default Field;
